import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { PermissionGuardService } from "./guards/permission-guard.service";
import { LoadDataGuardService } from "./guards/load-data-guard.service";

const appRoutes: Routes = [
  {
    path: "",
    loadChildren: () =>
      import("./pages/login/login.module").then((m) => m.LoginModule),
  },
  {
    path: "default",
    canActivate: [LoadDataGuardService],
    loadChildren: () =>
      import("./pages/default-page/default-page.module").then((m) => m.DefaultPageModule),
    data: { title: "Nenhuma tela selecionada" }
  },
  {
    path: "logout",
    canActivate: [],
    loadChildren: () =>
      import("./pages/logout/logout.module").then((m) => m.LogoutModule),
    data: { title: "Logout" }
  },
  {
    path: "erro",
    loadChildren: () =>
      import("./pages/erro/erro.module").then((m) => m.ErroModule),
    data: { title: "Erro" }
  },
  {
    path: "home",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/home/home.module").then((m) => m.HomeModule),
    data: {title: "Monitor - Fiscal"}
  },
  {
    path: "sintese-processo",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/processo/sintese-processo/sintese-processo.module").then(
        (m) => m.SinteseProcessoModule
      ),
    data: {title: "Síntese Processo"}
  },
  {
    path: "recebimento",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/recebimento/monitor/monitor.module").then((m) => m.MonitorModule),
    data: {title: "Monitor - Recebimento"}
  },
  {
    path: "recebimento/sintese-recebimento",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    runGuardsAndResolvers: 'always',
    loadChildren: () =>
      import("./pages/recebimento/sintese-recebimento/sintese-recebimento.module").then((m) => m.SinteseRecebimentoModule),
    data: {title: "Síntese Recebimento"}
  },
  {
    path: "manifesto",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/monitor-manifesto/monitor-manifesto.module").then(
        (m) => m.MonitorManifestoModule
      ),
    data: {title: "Monitor - Manifesto"}
  },
  {
    path: "relatorios/aprovacao",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/relatorios/logsemailaprovacao/logsemailaprovacao.module"
      ).then((m) => m.LogsemailaprovacaoModule),
    data: {title: "Relatórios - Pendente de Aprovação"}
  },
  {
    path: "relatorios/volumetria-processos",
    canActivate: [LoadDataGuardService],
    loadChildren: () =>
      import("./pages/relatorios/volumetria/volumetria.module").then(
        (m) => m.VolumetriaModule
      ),
    data: { title: "Relatórios - Volumetria Processo" }
  },
  {
    path: "relatorios/auxiliar",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/relatorios/auxiliar/auxiliar.module").then(
        (m) => m.AuxiliarModule
      ),
    data: { title: "Relatórios - Auxiliar" }
  },
  {
    path: "relatorios/processo-erro",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/relatorios/processo-erro/processo-erro.module").then(
        (m) => m.ProcessoErroModule
      ),
    data: { title: "Relatórios - Processos com Erro" }
  },
  {
    path: "relatorios/escrituracao",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/relatorios/escrituracao/escrituracao.module").then(
        (m) => m.EscrituracaoModule
      ),
    data: { title: "Relatórios - Escrituração" }
  },
  {
    path: "relatorios/notas-canceladas",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/relatorios/notas-canceladas/notas-canceladas.module").then(
        (m) => m.NotasCanceladasModule
      ),
    data: { title: "Relatórios - Notas Canceladas" }
  },
  {
    path: "relatorios/jobs",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/relatorios/jobs/jobs.module").then(
        (m) => m.JobsModule
      ),
    data: { title: "Relatórios - Acompanhamento Jobs" }
  },
  {
    path: 'relatorios/avancados',
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import('./pages/relatorios/avancados/avancado.module').then(
        (m) => m.AvancadoModule
      ),
    data: {title: "Relatórios - Avançados"}
  },
  {
    path: "admin/configuracoes",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/admin/configuracao/config.module").then(
        (m) => m.ConfigModule
      ),
    data: {title: "Administração - Configurações - Parâmetros"}
  },
  {
    path: "admin/validacoes",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/admin/validacao/validacao.module").then(
        (m) => m.ValidacaoModule
      ),
    data: {title: "Administração - Configurações - Validações"}
  },
  {
    path: "admin/imposto",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/admin/imposto/imposto.module"
      ).then((m) => m.ImpostoModule),
    data: {title: "Administração - Configurações - Imposto"}
  },
  {
    path: "admin/config-cnpj",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/admin/configuracao-cnpj/configuracao-cnpj.module"
      ).then((m) => m.ConfiguracaoCnpjModule),
    data: {title: "Administração - Configurações - Logotipo"}
  },
  {
    path: "admin/campos",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/admin/campos/campos.module").then(
        (m) => m.CamposModule
      ),
    data: {title: "Administração - Configurações - Campos Adicionais"}
  },
  {
    path: "admin/grupos",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/admin/grupofilial/grupofilial.module").then(
        (m) => m.GrupoFilialModule
      ),
    data: {title: "Administração - Gerenciamento - Grupo de Filiais"}
  },
  {
    path: "admin/usuarios",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/admin/usuario/usuario.module").then(
        (m) => m.UsuarioModule
      ),
    data: {title: "Administração - Gerenciamento - Usuários"}
  },
  {
    path: "admin/perfis",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import("./pages/admin/perfil/perfil.module").then(
        (m) => m.PefilModule
      ),
    data: {title: "Administração - Gerenciamento - Perfis"}
  },
  {
    path: "admin/tomador",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/admin/tomador-destinatario/tomador-destinatario.module"
      ).then((m) => m.TomadorDestinatarioModule),
    data: {title: "Administração - Gerenciamento - Tomador/Destinatário"}
  },
  {
    path: "admin/grupo-emissor",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/admin/grupo-emissor/grupo-emissor.module"
      ).then((m) => m.GrupoEmissorModule),
    data: {title: "Administração - Gerenciamento - Grupos de Emissor"}
  },
  {
    path: "admin/unidade-medida",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/admin/cadastros/unidade-medida/unidade-medida.module"
      ).then((m) => m.UnidadeMedidaModule),
    data: {title: "Administração - Processo - Unidade de Medida"}
  },
  {
    path: "admin/reclassificar-requisitante",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/admin/reclassificar-aprovador/reclassificar-aprovador.module"
      ).then((m) => m.ReclassificarAprovadorModule),
    data: { title: "Administração - Processo - Reclassificação de Requisitante" }
  },
  {
    path: "admin/fornecedores-confiaveis",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/admin/fornecedores-confiaveis/fornecedores-confiaveis.module"
      ).then((m) => m.FornecedoresConfiaveisModule),
    data: {title: "Administração - Processo - Fornecedores Confiáveis"}
  },
  {
    path: "admin/idprocesso",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/admin/identificador_processo/identificador-processo.module"
      ).then((m) => m.IdentificadorProcessoModule),
    data: {title: "Administração - Processo - Identificador Fluxo Processo"}
  },
  {
    path: "admin/fluxo-tolerancia",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/admin/tolerancia-fluxo/tolerancia-fluxo.module"
      ).then((m) => m.FluxoToleranciaModule),
    data: {title: "Administração - Processo - Tolerância por Fluxo Processo"}
  },
  {
    path: "admin/certificados",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/admin/certificados/certificados.module"
      ).then((m) => m.CertificadosModule),
    data: {title: "Administração - SEFAZ/SEFIN - Cadastro de Certificados"}
  },
  {
    path: "admin/nfe-cnpj",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/admin/nfe-cnpj/nfe-cnpj.module"
      ).then((m) => m.NfeCnpjModule),
    data: { title: "Administração - SEFAZ/SEFIN - CPF/CNPJ NF-e" }
  },
  {
    path: "admin/cte-cnpj",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/admin/cte-cnpj/cte-cnpj.module"
      ).then((m) => m.CteCnpjModule),
    data: {title: "Administração - SEFAZ/SEFIN - CPF/CNPJ CT-e"}
  },
  {
    path: 'admin/nfse-cnpj',
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        './pages/admin/nfse-cnpj/nfse-cnpj.module'
      ).then((m) => m.NfseCnpjModule),
    data: { title: "Administração - SEFAZ/SEFIN - CPF/CNPJ NFS-e" }
  },
  {
    path: "admin/participante",
    canActivate: [LoadDataGuardService, PermissionGuardService],
    loadChildren: () =>
      import(
        "./pages/admin/participante/participante.module"
      ).then((m) => m.ParticipanteModule),
    data: {title: "Administração - Gerenciamento - Participantes"}
  },

  // Esta rota precisa ser a última, visto que é uma rota de NotFound
  {
    path: "**",
    redirectTo: "/",
  },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes, { useHash: true, onSameUrlNavigation: 'reload' })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
